export default function (queryLocales, optionLocales, availablePageLocales = []) {
  let locales = [];

  const parseValidLocales = value => {
    if (!value || typeof value !== 'string') {
      return [];
    }

    const match = value.split(',').filter(el => (availablePageLocales || []).includes(el));

    if (match.length) {
      return match;
    }

    return [];
  };

  const queryAvailableLocales = parseValidLocales(queryLocales);
  const optionsAvailableLocales = parseValidLocales(optionLocales);

  if (queryAvailableLocales.length) {
    locales = queryAvailableLocales;
  } else if (optionsAvailableLocales.length) {
    locales = optionsAvailableLocales;
  }

  return locales;
}
